import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useEndpoints from '../../../API/apiConfig';

export default function InfoForm({ post, onSubmit, resetCurrentPost }) {
    const endpoints = useEndpoints();
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
    const [imageFileName, setImageFileName] = useState('')
    const [valImage, setValImage] = useState(false)

    useEffect(() => {
        reset(post || {});
        if (post?.image) {
            setImageFileName(post.image.name);
            setValue("image", post.image);
        }

    }, [post, reset]);

    const handleCancelEdit = () => {
        resetCurrentPost()
        console.log('reset')
        reset({ description: '', link: '', linkName: '', image: null, imageUrl: null });
        setImageFileName('')
    }

    const handleImageFileChange = (event) => {
        const file = event.target.files[0];
        setValImage(false)
        if (file) {
            setImageFileName(file.name);
            setValue("image", file);
        } else {
            setImageFileName('');
            setValue("image", null);
        }
    };

    const submitHandler = async (data) => {
        console.log(data);
        try {
            const formData = new FormData();
            data.idInfo && formData.append('idInfo', data.idInfo);
            formData.append('description', data.description);
            formData.append('link', data.link);
            formData.append('linkName', data.linkName);

            if (data.image instanceof File) {
                formData.append('image', data.image);
                if (!post) {
                    formData.append('imageUrl', null);
                }
                setValImage(false)
            } else if (data.image?.url) {
                formData.append('imageUrl', JSON.stringify(data.image));
                formData.append('image', null);
                setValImage(false)
            } else {
                setValImage(true)
                return
            }

            await onSubmit(formData);
            handleCancelEdit()
            setImageFileName('')
        } catch (error) {
            console.error("Ошибка при отправке данных:", error);
        }
    }

    return (
        <>
            {post &&
                <div className="manager__cancel">
                    <p>Идет редактирование</p>
                    <button className='manager__button' onClick={handleCancelEdit}>Отмена</button>
                </div>
            }
            <form onSubmit={handleSubmit(submitHandler)}>
                <div className="form__item">
                    <label htmlFor="description">Описание</label>
                    <div>
                        <textarea
                            id="description"
                            {...register("description", { required: "Это поле обязательно" })}
                        />
                        {errors.description && <span>{errors.description.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="link">Ссылка (начиная с http)</label>
                    <input
                        id="link"
                        {...register("link")}
                    />
                    {errors.link && <span>{errors.link.message}</span>}
                </div>

                <div className="form__item">
                    <label htmlFor="linkName">Назваине ссылки</label>
                    <input
                        id="linkName"
                        {...register("linkName")}
                    />
                    {errors.linkName && <span>{errors.linkName.message}</span>}
                </div>

                <div className="form__item">
                    <label htmlFor="image">Изображение (горизонтальное)</label>
                    <input
                        type='file'
                        id="image"
                        {...register("image")}
                        onChange={handleImageFileChange}
                        style={{ display: 'none' }}
                    />
                    <div className='fileInput'>
                        <button type="button" onClick={() => document.getElementById('image').click()}>
                            Выбрать файл
                        </button>
                        {imageFileName && <p>{imageFileName}</p>}
                        {errors.image && <span>{errors.image.message}</span>}
                        {valImage && <p>Это поле обязательно</p>}
                    </div>
                </div>

                <button type="submit">Сохранить</button>

            </form>
        </>
    );
}